import React from 'react';
import './ShipmentAdd.scss';
import ShipmentAddTrack from './ShipmentAddTrack/ShipmentAddTrack';
import ShipmentAddNowlun from './ShipmentAddNowlun/ShipmentAddNowlun';
import { getIcon } from '../../utils/images';
import { MixpanelConsumer } from 'react-mixpanel';
import ShipmentAddCsvTrack from './ShipmentAddCsvTrack/ShipmentAddCsvTrack';

const ShipmentAdd = ({ close, refetch, showSingle, showCSV, showNowlunForm, onTabChange, shipment }) => {
  return (
    <div className="ShipmentAdd">
      <div>
        <img src={getIcon('close')} onClick={close} />
      </div>
      <div>
        {showSingle && (
          <MixpanelConsumer>
            {mixpanel => (
              <ShipmentAddTrack
                refetch={refetch}
                close={close}
                mixpanel={mixpanel}
                onTabChange={onTabChange}
              />
            )}
          </MixpanelConsumer>
        )}

        {showNowlunForm && (
          <ShipmentAddNowlun
            refetch={refetch}
            close={close}
            shipment={shipment}
          />
        )}

        {showCSV && (
          <MixpanelConsumer>
            {mixpanel => (
              <ShipmentAddCsvTrack
                refetch={refetch}
                close={close}
                mixpanel={mixpanel}
              />
            )}
          </MixpanelConsumer>
        )}
      </div>
    </div>
  );
};

export default ShipmentAdd;
